export default {
    /**
     * Defines the list of market categories.
     *
     * @readonly
     * @enum {string}
     * @memberof Mojito.Modules.EventMarkets.types
     */
    MARKET_CATEGORIES: {
        MARKETS: 'markets',
        MATCH_ACCA: 'match_acca',
        PREBUILT_MATCH_ACCA: 'prebuilt_match_acca',
        FAST_MARKETS: 'fast_markets',
        PLAYER_PROP: 'player_prop',
    },

    /**
     * Defines the list of storable params. Used in redux and url query params.
     *
     * @readonly
     * @enum {string}
     * @memberof Mojito.Modules.EventMarkets.types
     */
    STORABLE_PARAMS: {
        MARKET_CAT: 'market_cat',
    },
};
